import script from "./elmentItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./elmentItem.vue?vue&type=script&lang=ts&setup=true"

import "./elmentItem.vue?vue&type=style&index=0&id=2c3fb1c1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c3fb1c1"]])

export default __exports__